module.exports = __webpack_public_path__ + "img/social.a4d3cc52.svg";